import { createContext } from 'react';

const GeneralContext = createContext({})
export const GeneralContextProvider = GeneralContext.Provider
export default GeneralContext;

export const VerifyContractContext = createContext({})
export const VerifyContractContextProvider = VerifyContractContext.Provider
